import TableCustomSort from '@/components/table-custom-sort/table-custom-sort'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import store from '@/store'
import formatFunctons from '@/components/mixins/format-functions'
import copyTextMixin from '@/components/mixins/copy-text-mixin'
import scrollToOrderTable from '@/components/mixins/scroll-to-order-table'
import sortFieldTable from '@/components/mixins/sort-field-table'
import IcEdit from '@/assets/svg/ic-edit.svg?inline'
import IcBicycle from '@/assets/svg/ic_bicycle.svg?inline'
import IcBicycleRed from '@/assets/svg/ic_bicycle-red.svg?inline'
import IcClear from '@/assets/svg/ic-clear.svg?inline'
import IcCar from '@/assets/svg/ic-car.svg?inline'
import IcCarRed from '@/assets/svg/ic-car-red.svg?inline'
import ChangeStartTimeModal from '@/components/modals/change-start-time-modal/change-start-time-modal.vue'
import TakeawayModal from '@/components/modals/takeaway-modal/takeaway-modal.vue'
import { getOrderId } from '@/utils/getOrderId'
import { getOrderIdTdClass } from '@/utils/getOrderIdTdClass'
import Loader from '@/components/loader/loader.vue'

const getTableColumns = function (workshopsCols = [], hideColumns = false) {
  return [
    {
      label: '№ заказа',
      field: 'id',
      type: 'number',
      thClass: 'order-id-td',
      tdClass: getOrderIdTdClass,
      sortable: false
    },
    {
      label: 'Статус',
      field: 'status',
      sortable: false,
      tdClass: 'status-td'
    },
    {
      label: 'Старт',
      field: 'times.start_at',
      tdClass: 'start-time-td',
      sortable: false
    },
    {
      label: 'Адрес',
      field: 'address.full_address',
      sortable: false,
      width: '400px',
      tdClass: row => {
        return `address-td status-order-color__${row.status}--opacity`
      }
    },
    {
      label: 'Доставить',
      field: 'times.delivery_to',
      tdClass: 'delivery-td',
      sortable: false
    },
    {
      label: 'На кухне',
      field: 'times.time_in_cooking',
      type: 'number',
      width: '90px',
      sortable: false
    },
    ...workshopsCols.map(item => {
      return {
        label: item.title,
        field: `workshops.${item.id}`,
        sortable: false,
        tdClass: 'workshop-dishes-td',
        thClass: 'workshop-dishes-td',
        width: '36px'
      }
    }),
    {
      label: 'Готов',
      field: 'times.cooked_at',
      sortable: false,
      width: '70px'
    },
    {
      label: 'Ячейка',
      field: 'cells',
      sortable: false
    },
    {
      label: 'Маршрут',
      field: 'route_task.id',
      type: 'number',
      sortable: false
    },
    {
      label: 'Курьер',
      field: 'route_task.courier.last_name',
      tdClass: 'courier-td',
      sortable: false
    },
    {
      label: '',
      field: 'add_to_route',
      sortable: false,
      tdClass: 'add-to-route-td',
      thClass: 'add-to-route-td',
      width: '40px'
    },
    {
      label: 'Комментарий',
      field: 'note',
      sortable: false,
      tdClass: 'note-td',
      hidden: hideColumns,
      width: '400px'
    }
  ]
}

export default {
  name: 'MainTable',
  /**
   * formatFuncton:
   *  getFormatDate
   *  getShortId
   *  getCookedTime
   *
   * copyTextMixin:
   *  -onCopyText
   *  -isShiftPress
   */
  mixins: [formatFunctons, copyTextMixin, scrollToOrderTable, sortFieldTable],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    sortFields: {
      type: Array,
      default: () => []
    }
  },
  components: {
    TableCustomSort,
    IcEdit,
    IcBicycle,
    IcBicycleRed,
    IcClear,
    IcCar,
    IcCarRed,
    ChangeStartTimeModal,
    TakeawayModal,
    Loader
  },
  data() {
    /**
     * опции columns рективны только после создания,
     * а если переходить допустим с другой страницы,
     * то придется в прямую здесь проверить условие скрытия колонок
     */
    const hideColumns = !!store.state.routeTasks.editedRouteTask.length
    return {
      scrollLeft: 0,
      orderToEdit: null,
      table: {
        columns: getTableColumns.bind(this, [], hideColumns)()
      },
      takeawayData: {
        orderId: '',
        orderStatus: ''
      }
    }
  },
  computed: {
    ...mapState({
      orders: state => state.orders.orders,
      editedRouteTask: state => state.routeTasks.editedRouteTask,
      workshopsInfo: state => state.orders.workshopsInfo,
      editedRouteTaskInfo: state => state.routeTasks.editedRouteTaskInfo,
      workshopLoads: state => state.orders.workshopLoads,
      couriers: state => state.couriers.couriers,
      orderStatuses: state => state.sharedData.orderStatuses
    }),
    ...mapGetters({
      isAutoRouteTaskActive: 'logistics/isAutoRouteTaskActive',
      getWorkshopColor: 'orders/getWorkshopColor',
      getWorkshopLoadObjById: 'orders/getWorkshopLoadObjById'
    }),
    hideColumns() {
      return !!this.editedRouteTask.length
    }
  },
  mounted() {
    const vgtResponsive = this.$refs.table.$el.querySelector('.vgt-responsive')
    vgtResponsive.addEventListener('scroll', () => {
      this.scrollLeft = vgtResponsive.scrollLeft
    })
  },
  methods: {
    ...mapActions({
      getRouteTaskById: 'routeTasks/getRouteTaskById'
    }),
    ...mapMutations({
      setEditedRouteTask: 'routeTasks/SET_EDITED_ROUTE_TASK',
      setEditedRouteTaskInfo: 'routeTasks/SET_EDITED_ROUTE_TASK_INFO'
    }),

    getOrderId,

    onSortChange(event) {
      this.$emit('sort-change', event)
    },
    getRoutTaskText(order, isShort = false) {
      return `м 
        ${isShort ? this.getShortId(order.route_task.id) : order.route_task.id}${
        order.route_task.allowed_by_foot_courier ? ' (в)' : ''
      }`
    },
    getWorkshopInfo(workshopArr, workshopId) {
      const workshopInfo = workshopArr.find(
        item => item.workshop_id.toString() === workshopId.toString()
      )
      if (workshopInfo) {
        return workshopInfo
      }
      return {
        items_count: 0,
        /**
         * это только для клиента
         */
        status: 'no_status'
      }
    },
    getCourierName(route_task) {
      if (route_task && route_task.courier) {
        return `${route_task.courier.last_name} ${route_task.courier.first_name
          .charAt(0)
          .toUpperCase()}.`
      }
      return ''
    },
    isFootCourier(courierId) {
      let result = false
      const courierObj = this.couriers.find(c => c.courier_id === courierId)
      if (courierObj) {
        result = courierObj.is_foot_courier
      }
      return result
    },
    toggleOrderToRoute(order) {
      if (this.editedRouteTaskInfo && this.editedRouteTaskInfo.courier) {
        this.setEditedRouteTask([])
      }
      if (this.editedRouteTask.find(o => this.getOrderId(o) === this.getOrderId(order))) {
        this.setEditedRouteTask(
          this.editedRouteTask.filter(o => this.getOrderId(o) !== this.getOrderId(order))
        )
      } else {
        this.setEditedRouteTask([...this.editedRouteTask, order])
      }
      this.setEditedRouteTaskInfo(null)
    },
    addOrderToRoute(order) {
      if (
        this.editedRouteTask.find(o => this.getOrderId(o) === this.getOrderId(order)) === undefined
      ) {
        this.setEditedRouteTask([...this.editedRouteTask, order])
        this.setEditedRouteTaskInfo(null)
      }
    },
    clearAddedOrders() {
      this.setEditedRouteTask([])
      this.setEditedRouteTaskInfo(null)
    },
    editStartTime(order) {
      this.orderToEdit = order
      this.$nextTick(() => {
        this.$refs['change-start-time-modal'].show()
      })
    },
    selectRouteTask(event, order) {
      if (this.isShiftPress) {
        this.onCopyText(event, this.getRoutTaskText(order))
        return
      }
      this.getRouteTaskById(order.route_task.id)
    },
    openTakeawayModal(order) {
      this.takeawayData.orderId = String(order.id)
      this.takeawayData.orderStatus = order.status
      this.$nextTick(() => {
        this.$refs['takeaway-modal'].show()
      })
    },
    openAddressMap(order) {
      if (order.route_task) {
        this.getRouteTaskById(order.route_task.id)
      } else if (order.may_be_included_in_route_task) {
        this.addOrderToRoute(order)
      }
    },
    getStatusDishClass(order, column) {
      const status = this.getWorkshopInfo(order.workshops, column.field.split('.')[1]).status
      const isAllDishesDone =
        order.workshops.filter(w => w.status === 'done').length === order.workshops.length
      if (
        isAllDishesDone &&
        this.orderStatuses[order.status].order_number > this.orderStatuses.cooked.order_number &&
        status !== 'no_status'
      ) {
        return `status-order-color__${order.status}`
      }
      return `status-dish-color__${status}`
    },
    getShortNote(note) {
      if (note && note.length > 60) {
        return `${note.slice(0, 60)}...`
      }
      return note
    }
  },
  watch: {
    hideColumns: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          /**
           * Этих столцов может быть несколько,
           * поэтому оформим их в массив operateCols
           */
          const operateColFields = ['note', 'route_task.courier.last_name', 'times.time_in_cooking']
          const operateCols = operateColFields.map(field => {
            return this.table.columns.find(colObj => colObj.field === field)
          })
          operateCols.forEach(col => {
            col.hidden = this.hideColumns
          })
        })
      }
    },
    workshopsInfo: {
      immediate: true,
      handler() {
        if (this.workshopsInfo.length) {
          this.table.columns = getTableColumns.bind(this, this.workshopsInfo, this.hideColumns)()
        }
      }
    }
  }
}
